<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" :max-items="itemsPerPage" :data="incidents">
      <template slot="thead">
        <vs-th width="2%" sort-key="ref">N° TICKET</vs-th>
        <vs-th width="30%" sort-key="title">Titre</vs-th>
        <vs-th width="5%" sort-key="status">Statut</vs-th>
        <vs-th width="10%" sort-key="customer">Client</vs-th>
        <vs-th width="10%" sort-key="service">Application</vs-th>
        <vs-th width="2%" sort-key="departement">Service</vs-th>
        <vs-th width="10%" sort-key="arrived_at">Date arrivée</vs-th>
        <vs-th width="10%" sort-key="arrived_at">Date création</vs-th>
        <vs-th width="2%">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ tr.ref }}</vs-td>
            <vs-td>
              <read-more
                more-str="Voir plus"
                :text="tr.title"
                link="#"
                less-str="Voir moins"
                :max-chars="20"
              ></read-more>
            </vs-td>
            <vs-td>
              <vs-chip>{{ tr.status }}</vs-chip>
            </vs-td>
            <vs-td> {{ tr.customer }} </vs-td>
            <vs-td> {{ tr.departement }} </vs-td>
            <vs-td> {{ tr.service }} </vs-td>
            <vs-td>
              <p class="product-price">{{ tr.created_at | title }}</p>
            </vs-td>
            <vs-td>
              <p class="product-price">{{ tr.arrived_at | title }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <div class="flex" @click="goToSingle(tr.id, tr.has_proved)">
                  <feather-icon
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  name: "incidents",
  props: {
    incidents: {
      type: Array,
    },
  },
  data() {
    return {
      itemsPerPage: 10
    };
  },
  methods: {
    goToSingle(id, el) {
      let t = el ? 1 : 2;
      this.$router.push("/requests/" + id + "/detail/" + t);
    }
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: right;
    }
  }
}

#readmore {
  font-weight: bold;
  text-decoration: underline;
}
</style>
